import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { ControlLabel, FormControl, HelpBlock } from 'react-bootstrap'

import { FormGroup } from 'internal-components/src/components/Form'

export default function PhoneTailDetails({ errors, setData, signup }) {
  return (
    <div className="phone-details">
      <h4>Phone Line Details</h4>

      <FormGroup
        bsSize="large"
        controlId="phoneTail"
        errors={errors}
        errorKey="data[tail.phone]"
      >
        <ControlLabel>Phone Number</ControlLabel>

        <FormControl
          onChange={e => setData('tail.phone', e.target.value)}
          placeholder="Phone Number"
          type="text"
          value={signup.getIn(['data', 'tail.phone']) || ''}
        />
        <HelpBlock>
          This service is installed on top of a phone service and we require a
          phone number that identifies the phone service that you&apos;d like to
          have this service installed on.
        </HelpBlock>
      </FormGroup>
    </div>
  )
}

PhoneTailDetails.propTypes = {
  errors: Ipt.map.isRequired,
  setData: Pt.func.isRequired,
  signup: Ipt.record.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Signup/ServiceDetail/PhoneTailDetails.jsx